import gsap from 'gsap';

export { gsap };

export function prefersReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/** Shared motion tokens for shell / sidebar. */
export const ORG_MOTION = {
  pageSlideIn: 12,
  pageSlideOut: 8,
  pageIn: 0.28,
  pageOut: 0.2,
  pageEaseIn: 'power2.out',
  pageEaseOut: 'power2.in'
};
